import { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import ProjectCard from './ProjectCard';
import { allProjects } from '../data/projects';

const ProjectsPage = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="animate-fade-in">
      <button 
        onClick={() => navigate('/')}
        className="dev-button flex items-center gap-2 mb-8 group"
      >
        <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" />
        <span>Back to Home</span>
      </button>
      
      <h1 className="text-4xl font-bold font-mono mb-4 text-dev-text">
        <span className="text-dev-accent">//</span> All Projects
      </h1>
      <p className="text-dev-text-muted font-mono mb-8">
        A collection of {allProjects.length} projects I've built
      </p>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {allProjects.map(project => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>
    </div>
  );
};

export default ProjectsPage; 